// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component__Label__Date[data-v-6816772a] {\n  gap: 8px;\n}\n.Field__Component__Label__Date > div[data-v-6816772a] {\n    flex: 1 1 0;\n    min-width: 0;\n    width: 100%;\n    margin: 15px 0;\n}\n", ""]);
// Exports
module.exports = exports;
